import { GenericFunction } from '../';


/**
 * 
 */
export class SeriesFunction extends GenericFunction {
  constructor(f, {label, parameters = [], maxInputSize = 1} = {}) {
    super(f, {label, parameters, maxInputSize});
  }
}